import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import Register from "./pages/Register";
import ProtectedLayout from "./components/ProtectedLayout";
import Notes from "./pages/Notes";
import NoteFolderView from "./pages/notes/NoteFolderView";
import Bookmarks from "./pages/Bookmarks";
import Todo from "./pages/Todo";
import TodoView from "./pages/todo/TodoView";
import ProjectLog from "./pages/ProjectLog";
import ProjectLogView from "./pages/project-log/ProjectLogView";
import Storage from "./pages/Storage";
import StorageFolderView from "./pages/storage/StorageFolderView";
import User from "./pages/User";
import Search from "./pages/Search";
import Admin from "./pages/Admin";

export default function App() {
    return (
        <Router>
            <Routes>
                {/* Public routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* Protected routes (with layout) */}
                <Route
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/notes" element={<Notes />} />
                    <Route path="/notes/:folderId" element={<NoteFolderView />} />
                    <Route path="/bookmarks" element={<Bookmarks />} />
                    <Route path="/todo" element={<Todo />} />
                    <Route path="/todo/:id" element={<TodoView />} />
                    <Route path="/project-log" element={<ProjectLog />} />
                    <Route path="/project-log/:id" element={<ProjectLogView />} />
                    <Route path="/storage" element={<Storage />} />
                    <Route path="/storage/:id" element={<StorageFolderView />} />
                    <Route path="/user" element={<User />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
                </Route>
            </Routes>
        </Router>
    );
}
